export default () => ({
  persons: [],
  personsCount: 0,
  business: [],
  businessCount: 0,
  companies: [],
  companiesCount: 0,
  leads: [],
  leadsCount: 0,
  status: [],
  statusCount: 0,
  needs: [],
  needsCount: 0,
  interactions: [],
  funnelStages: [],
  funnelStagesCount: 0,
  variables: [],
  variablesCount: 0,
  businessByStage: [],
  businessByStageCount: 0,
  sales: [],
  salesCount: 0,
  eventTypes: [],
  varTypes: [],
  varTypesCount: 0,
  agenda: [],
  agendaCount: 0,
  defaultCompany: {
    page: 0,
    itemsPerPage: 10,
    mutation1: "setCompanies",
    mutation2: "setCountCompanies",
    entity: "companies",
  },
  defaultPerson: {
    page: 0,
    itemsPerPage: 10,
    mutation1: "setPersons",
    mutation2: "setCountPersons",
    entity: "persons",
    pagePagination: 0,
  },
  defaultLead: {
    page: 0,
    itemsPerPage: 10,
    mutation1: "setLeads",
    mutation2: "setCountLeads",
    entity: "leads",
    pagePagination: 0,
  },
  defaultNeed: {
    page: 0,
    itemsPerPage: 10,
    mutation1: "setNeeds",
    mutation2: "setCountNeeds",
    entity: "needs",
  },
  defaultFunnelStages: {
    page: 0,
    itemsPerPage: 10,
    mutation1: "setFunnelStages",
    mutation2: "setCountFunnelStages",
    entity: "funnel_stages",
  },
  defaultVariable: {
    page: 0,
    itemsPerPage: 10,
    mutation1: "setVariables",
    mutation2: "setCountVariables",
    entity: "variables",
  },
  defaultBusinessByStage: {
    page: 0,
    itemsPerPage: 10,
    mutation1: "setBusinessByStage",
    mutation2: "setBusinessByStageCount",
    entity: "persons_by_funnel_stage",
  },
  defaultBusiness: {
    page: 0,
    itemsPerPage: 10,
    mutation1: "setBusiness",
    mutation2: "setCountBusiness",
    entity: "business_download",
    pagePagination: 0,
  },

  defaultSales: {
    page: 0,
    itemsPerPage: 10,
    mutation1: "setSales",
    mutation2: "setSalesCount",
    entity: "business_download",
  },
  defaultVarTypes: {
    page: 0,
    itemsPerPage: 10,
    mutation1: "setVarTypes",
    mutation2: "setVarTypesCount",
    entity: "type_variables",
  },
  defaultStatus: {
    page: 0,
    itemsPerPage: 10,
    mutation1: "setStatus",
    mutation2: "setCountStatus",
    entity: "status",
  },
  defaultAgenda: {
    page: 0,
    itemsPerPage: 500,
    mutation1: "setAgenda",
    mutation2: "setCountAgenda",
    entity: "agenda",
  },
  total_ventas: 0,
  loadingUpdate: false,
  users: [],
  idUserFilter: null,
  filterByUser: false,
  filterSaleByUser: false,
  filterPersonByUser: false,
  filterLeadByUser: false,
  filterStageByUser: false,
  lead: false,
  companyToUpdate: null,
  statusBusiness: [],
  statusBusinessFilter: null,
  usersSelectBusiness: null,
  filterBusinessByUser: null,
  statusLeadFilter: "True",
  config: {},
  statusLead: [],
  statusLeadCount: 0,
  senders: [],
  eventDetail: null,
  personsVars: [],
  facebook: [],
  facebookCount: 0,
  formulario: [],
  formularioCount: 0,
  join: [],
  joinCount: 0,
  newEvent: null,
  filterBusiness: {
    initialDate: null,
    finalDate: null,
    status: null,
  },
  origins: [],
  crm: [],
  crmCount: 0,
  statusPerson: [],
  recompra: [],
  recompraCount: [],
  filters: {
    personUrl: null,
    personOrigin: null,
    personCompany: null,
    personStatus: null,
    personInitDate: null,
    personFinishDate: null,
    campaign: null,
    line: null,

    leadUrl: null,
    leadOrigin: null,
    leadCompany: null,
    leadStatus: null,
    leadInitDate: null,
    leadFinishDate: null,
    leadCampaign: null,
    LeadLine: null,

    interaccionUrl: null,
  },
  businessUrl: null,
  antiguos: null,
  antiguosCount: null,
  initDateBusiness: null,
  endDateBusiness: null,
  businessUsersFilter: null,
  campaigns: [],
  lineasNegocio: [],
  businessVars: [],
  companyVars: [],
  gruposAgenda: [],
  gpsCount: 0,
  personal_contact: [],
  cities: [],
  showAnotations: false,
  infoAnotationsCommiments: null,
  eventSelected: null,
});
